import { OdinIcon, OdinIconSize, Popover, PopoverContent, PopoverTrigger } from '@myosh/odin-components';
import { type ReactElement, type ReactNode, useState } from 'react';
import type { Layout } from '../../redux/config/layout';
import { PermissionTabIcon } from './permissions-tab-icon';

type TabHeaderSettingsPopoverProps = {
  children: ReactNode | ReactElement;
  layout: Layout;
};
export const TabHeaderSettingsPopover = ({ children, layout }: TabHeaderSettingsPopoverProps) => {
  const [settingsOpened, setSettingsOpened] = useState<boolean>(false);

  return (
    <Popover open={settingsOpened} onOpenChange={setSettingsOpened}>
      <PopoverTrigger>
        <OdinIcon icon="Settings" size={OdinIconSize.ExtraSmall} />
      </PopoverTrigger>
      <PopoverContent
        side="bottom"
        align="start"
        sideOffset={2}
        className="cursor-pointer bg-gray-5 shadow-sm w-fit gap-2 p-2 rounded-none"
      >
        {children}
        <PermissionTabIcon layout={layout} onHidden={() => setSettingsOpened(false)} />
      </PopoverContent>
    </Popover>
  );
};
